import type { PrimitiveType } from '#layers/data-model';
import { isPrimitiveTypeBoolean, isPrimitiveTypeFloat, isPrimitiveTypeInteger, isPrimitiveTypeJson } from '#layers/data-model';

export function serializeRawValue(value: unknown, type: PrimitiveType): string {
	if (value === null || value === undefined) return '';
	if (isPrimitiveTypeJson(type)) return JSON.stringify(value, null, 2);
	return String(value);
}

export function parseRawValue(text: string, type: PrimitiveType): unknown {
	if (text === '') return null;
	if (isPrimitiveTypeInteger(type)) return Number.parseInt(text, 10);
	if (isPrimitiveTypeFloat(type)) return Number.parseFloat(text);
	if (isPrimitiveTypeBoolean(type)) return text === 'true' || text === '1';
	if (isPrimitiveTypeJson(type)) return JSON.parse(text);
	// TODO: Handle decimal type properly once studio supports decimal input
	// For now, decimal values are kept as strings to preserve precision
	return text;
}

export function validateRawValue(text: string, type: PrimitiveType): string | undefined {
	if (!isPrimitiveTypeJson(type)) return undefined;

	// Empty input maps to null on parse, so treat it as valid rather than letting JSON.parse('') throw.
	if (text === '') return undefined;

	try {
		JSON.parse(text);
		return undefined;
	}
	catch {
		return 'errors.invalid_json';
	}
}
